export default __webpack_public_path__ + "static/media/rotate.33ba460b.svg";